import { render, staticRenderFns } from "./CandidateDriverList.vue?vue&type=template&id=6b5c4174&scoped=true&"
import script from "./CandidateDriverList.vue?vue&type=script&lang=js&"
export * from "./CandidateDriverList.vue?vue&type=script&lang=js&"
import style0 from "./CandidateDriverList.vue?vue&type=style&index=0&id=6b5c4174&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5c4174",
  null
  
)

export default component.exports